module.exports = __webpack_public_path__ + "static/media/feature_img_ss2.4677d229.png";